<template>
  <div class="row">
    <div class="col-sm-3" v-for="page in pages" :key="page.name">
      <router-link tag="div" :to="`/admin/city_hall_mapper/${page.path}`" class="card card-admin">
        <div class="card-body text-center">
          <strong>
            {{ page.name }}
          </strong>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    data: () => ({
      pages: [
        { name: 'Consultas', path: 'consults' },
        { name: 'Eventos', path: 'events' }
      ]
    }),
    name: 'Index',
  }
</script>

<style scoped>

  .card-admin {
    cursor: pointer;
  }
  .card-admin:hover {
    transition: background-color 1s;
    background: #8080803d;
  }
</style>